import { ICategoryResponseList } from "@amzn/rangoli-seller-desktop-utils/src/index";
import { useQuery } from "react-query";

import { smartbizUrl } from "../ApiClient";
import { QueryParams } from "../../enums/QueryParams";

const { GET_ALL_CATEGORIES_KEY } = QueryParams;

const getAllCategoriesAPI = async (
  pageCursor: number
): Promise<ICategoryResponseList> => {
  const shopId = localStorage.getItem("shopId");
  const categoriesEndPoint = `/stores/${shopId}/categories?page-cursor=${pageCursor}`;
  const response = await smartbizUrl.get(categoriesEndPoint);
  return response?.data;
};

export const useGetAllCategoriesQuery = (pageCursor: number) => {
  const { data, isLoading, isError, refetch, isRefetching } =
    useQuery<ICategoryResponseList>(
      [GET_ALL_CATEGORIES_KEY, pageCursor],
      (): Promise<ICategoryResponseList> => getAllCategoriesAPI(pageCursor),
      { refetchOnWindowFocus: false, refetchOnMount: false, enabled: false }
    );

  return { data, refetch, isLoading, isError, isRefetching };
};
